import { useEffect, useMemo, useState } from "react";
import { useStudioData } from "../studio.ts";
import { ClientList, FooterNote, Headline, InstagramLink } from "./SiteParts.tsx";
import { Gallery } from "./Gallery.tsx";

const PAGE_MARGIN = 16;

export const StudioCopy = () => {
	const { services, clients } = useStudioData();
	const [copy, setCopy] = useState<HTMLElement | null>(null);

	// Only featured clients appear in the gallery; until any are featured, everyone does
	const shown = useMemo(() => {
		const featured = clients.filter((c) => c.featured && c.media.length);
		return featured.length ? featured : clients;
	}, [clients]);

	// On desktop the copy scrolls with the page until its last line reaches
	// the bottom of the screen, then stays put beside the longer gallery.
	// Its sticky offset is the screen height minus its own height.
	useEffect(() => {
		if (!copy) return;
		const update = () =>
			copy.style.setProperty(
				"--nh-copy-top",
				`${Math.min(PAGE_MARGIN, window.innerHeight - copy.offsetHeight)}px`
			);
		update();
		const observer = new ResizeObserver(update);
		observer.observe(copy);
		window.addEventListener("resize", update);
		return () => {
			observer.disconnect();
			window.removeEventListener("resize", update);
		};
	}, [copy]);

	return (
		<div className="nh-home">
			<main ref={setCopy} className="nh-main nh-copy">
				<Headline />
				<div className="nh-rest fade-in">
					<InstagramLink />

					<div>
						<p className="nh-label">Services</p>
						{services.map((service) => (
							<p key={service}>{service}</p>
						))}
					</div>

					<ClientList label="Clients" clients={clients} numbered />

					<FooterNote />
				</div>
			</main>

			<Gallery clients={shown} />
		</div>
	);
};
